export default {
  'verificationcheck.verifycode': 'コードの確認',
  'verificationcheck.gotoprofile': 'プロファイルへ',
  'verificationcheck.entercode': '確認コードの入力',
  'verificationcheck.maintext': '送られてきた確認コードを',
  'verificationcheck.continuetext': '入力してください',
  'verificationcheck.evaluate': '評価',
  'verificationcheck.resendcode': 'クリックしてコードを再送信',
};
